import React, { useState } from "react";
import { Mail, Phone, MapPin, Send, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/Contact.module.css";
import heroBackground from "../assets/images/image8.png";

export default function Contact() {
  const navigate = useNavigate();
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted:", contactForm);
    setSubmitStatus("success");
    setContactForm({ name: "", email: "", phone: "", subject: "", message: "" });
    setTimeout(() => setSubmitStatus(null), 5000);
  };

  return (
    <div className={styles.contactPage}>
      {/* Hero Section */}
      <section
        className={styles.hero}
        style={{
          backgroundImage: `url(${heroBackground})`,
        }}
      >
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Contact Us</h1>
          <p className={styles.heroSubtitle}>
            We'd love to hear from you. Get in touch with Calvary Wide Fellowship Ministries.
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className={`${styles.section} ${styles.sectionWhite}`}>
        <div className={styles.contentWrapper}>
          <div className={styles.contactWrapper}>
            <div className={styles.contactInfo}>
              <div>
                <h2 className={styles.sectionTitle}>Get In Touch</h2>
                <p className={styles.sectionDesc}>
                  Have questions about our church, want to join our community, or need prayer support? Send us a message and we'll respond as soon as possible.
                </p>
              </div>
              <div className={styles.contactDetails}>
                <div className={styles.contactItem}>
                  <Mail size={28} className={styles.contactItemIcon} />
                  <div>
                    <div className={styles.contactItemTitle}>Email</div>
                    <a 
                      href="mailto:info@cwfm.church"
                      className={styles.contactItemText}
                    >
                      info@cwfm.church
                    </a>
                  </div>
                </div>
                <div className={styles.contactItem}>
                  <Phone size={28} className={styles.contactItemIcon} />
                  <div>
                    <div className={styles.contactItemTitle}>Phone</div>
                    <a 
                      href="tel:+15551234567"
                      className={styles.contactItemText}
                    >
                      +1 (555) 123-4567
                    </a>
                  </div>
                </div>
                <div className={styles.contactItem}>
                  <MapPin size={28} className={styles.contactItemIcon} />
                  <div>
                    <div className={styles.contactItemTitle}>Head Office</div>
                    <div className={styles.contactItemText}>
                      Kigali, Rwanda
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleContactSubmit} className={styles.contactForm}>
              <div className={styles.formGroup}>
                <label htmlFor="name" className={styles.formLabel}>
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={contactForm.name}
                  onChange={handleContactChange}
                  className={styles.formInput}
                  placeholder="Your name"
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.formLabel}>
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={contactForm.email}
                  onChange={handleContactChange}
                  className={styles.formInput}
                  placeholder="your.email@example.com"
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="phone" className={styles.formLabel}>
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={contactForm.phone}
                  onChange={handleContactChange}
                  className={styles.formInput}
                  placeholder="+1 (555) 123-4567"
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="subject" className={styles.formLabel}>
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={contactForm.subject}
                  onChange={handleContactChange}
                  className={styles.formInput}
                  placeholder="What is this about?"
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="message" className={styles.formLabel}>
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={contactForm.message}
                  onChange={handleContactChange}
                  className={styles.formTextarea}
                  placeholder="Your message here..."
                  rows="6"
                  required
                />
              </div>
              <button
                type="submit"
                className={`${styles.btnPrimary} ${styles.contactSubmitBtn}`}
              >
                <Send size={18} />
                Send Message
              </button>
              {submitStatus === "success" && (
                <div className={styles.successMessage}>
                  ✓ Thank you! We've received your message and will get back to you soon.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.sectionBlue}>
        <div className={`${styles.contentWrapper} ${styles.section}`}>
          <div style={{ textAlign: "center" }}>
            <h2 className={styles.sectionTitle}>
              Questions About Our Community?
            </h2>
            <p className={styles.sectionDesc}>
              Visit us at one of our fellowship locations or join us online next Sunday
            </p>
            <div className={styles.heroButtons}>
              <button 
                className={`${styles.btnPrimary} ${styles.hoverLift}`}
                onClick={() => navigate("/fellowship")}
              >
                <span>Visit A Location</span>
                <ChevronRight size={20} />
              </button>
              <button 
                className={`${styles.btnSecondary} ${styles.hoverLift}`}
                onClick={() => navigate("/")}
              >
                <span>Back To Home</span>
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
